import React from 'react'
import {useIntl} from 'react-intl'

type Props = {
  isVisible: boolean
  onDrop: (e: React.DragEvent<HTMLDivElement>) => void
}

const DragOverlay: React.FC<Props> = ({isVisible, onDrop}) => {
  const intl = useIntl()

  if (!isVisible) return null

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
  }

  return (
    <div className='drag-overlay' onDragOver={handleDragOver} onDrop={onDrop}>
      <div className='drag-overlay__content'>
        <h3 className='fw-bold text-dark mb-0'>{intl.formatMessage({id: 'DRAG_AND_DROP_HERE'})}</h3>
      </div>
    </div>
  )
}

export {DragOverlay}
